<style scoped lang="scss">
  .wrap-products{
    .container{
      width: 1000px;
    }
    .top-con{
      display: flex;
    }
    .pro-img{
      width:400px;
      margin-right: 40px;
      img{
        display: block;
        font-size: 0;
        width:400px;
        height:400px;
      }
      ul{
        display: flex;
        margin:20px -10px 0;
        li{
          margin-right: 20px;
          cursor: pointer;
          border:4px solid #fff;
          &.active{
            border-color:#014492;
          }
          &:last-child{
            margin-right: 0;
          }
        }
        img{
          width:110px;
          height:110px;
        }
      }
    }
    .pro-info{
      .title{
        font-size: 30px;
        font-weight: bold;
        margin-top: 20px;
      }
      .price{
        font-size: 24px;
        font-weight: bold;
        color: #014492;
        margin: 30px 0;
        small{
          font-size: 14px;
          font-weight: normal;
          margin-left: 10px;
        }
      }
    }
    .details{
      padding:10px 40px 20px;
      margin-top: 40px;
      .title{
        color: #014492;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
        background: #F6FAFD;
        padding:10px 0;
      }
      img{
        width: 100%;
        margin-top: 20px;
      }
    }
  }
</style>
<template>
  <div class="wrap wrap-products">
    <section class="container">
      <div class="top-con">
        <div class="pro-img">
          <img :src="details.imgUrls[currentPro]" class="img-fluid">
          <ul>
            <li v-for="(item, index) in details.imgUrls" :key="index" :class="{active: currentPro === index}" @click="currentPro = index"><img :src="item"></li>
          </ul>
        </div>
        <div class="pro-info">
          <div class="title">{{details.name}}</div>
          <p class="mt20 text-gray9" v-html="details.title"></p>
          <div class="price">{{details.price}}<small>积分</small></div>
          <div class="mt30">
            <el-button type="primary" @click="toExchange">立即兑换</el-button>
          </div>
        </div>
      </div>
      <div class="details">
        <div class="title">商品详情</div>
        <div v-html="details.detail" class="mt30"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { pointsGoodsDetail, customerPoints } from '@/services/api.index'
export default {
  data () {
    return {
      num: 1,
      specs: '',
      currentPro: 1,
      currentSpecs: 1,
      activeName: 'first',
      details: {},
      id: this.$route.query.id,
      points: {}
    }
  },
  created() {
    this.getDetails()
    this.getPoints()
  },
  methods: {
    getDetails () {
      pointsGoodsDetail(this.id).then(res => {
        res.data.imgUrls.unshift(res.data.mainImgUrl)
        this.details = res.data
      })
    },
    // 立即兑换
    toExchange () {
      if (this.details.price > this.points.availablePoints) {
        this.$confirm('您的积分不足，无法兑换', '提示', {
        })
        return
      }
      this.$router.push(`/user/order_intergal?id=${this.id}`)
    },
    // 积分汇总
    getPoints () {
      customerPoints().then(res => {
        this.points = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/product_details.vue